module.exports = [{
      plugin: require('/tmp/70ed9f00/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/70ed9f00/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/70ed9f00/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/tmp/70ed9f00/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
